import comp from "./UIInputCheckList.js";
export default comp;
